import React, { FC } from 'react';
import { Post } from '../Post';
import { PostsCardLoading } from '../Loader';
import { usePosts } from '../../hooks/usePost';
import { PostsProps, TruncateProps } from './Posts.types';
import './posts.scss';

const Posts: FC<PostsProps & TruncateProps> = ({ url, user, hideActions, hideCommentsTag }) => {
    const { posts, loading, fullPost, loadingRef } = usePosts({ url: `${url}/api/posts` });

    return (
        <div className='sobrusPosts'>
            {loading && posts?.length === 0 ? (
                <PostsCardLoading />
            ) : (
                posts.map((post, index) => (
                    <Post key={post?.id} {...{ url, index, post, user, hideActions, hideCommentsTag }} />
                ))
            )}
            {!loading && fullPost ? <div className='sobrusPosts__end'>Vous avez tout visualisé</div> : ''}
            {!fullPost && posts?.length > 0 && loading ? <PostsCardLoading /> : ''}
            {!fullPost && posts?.length > 0 ? <div ref={loadingRef} className='sobrusPosts__more' /> : ''}
        </div>
    );
};

export default Posts;
